import React from 'react'
import { Button, Select } from 'antd'
import { withRouter } from 'react-router-dom'
import MemberAvatarView from '../../../elements/Members/MemberAvatarView'
import CustomTable from '../../../elements/Table/CustomTable'
import Status from '../../../elements/Status'
import OrganisationsSelect from '../../../elements/Select/Organistaions'

const NewEmployeeButton = withRouter(({ history }) => {
  return (
    <Button
      type="primary"
      icon={'plus'}
      size={'small'}
      onClick={() => {
        history.push('/people/dashboard/new')
      }}>
      New
    </Button>
  )
})
const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 150,
    Cell: ({ value, original }) => (
      <a onClick={() => (window.location = `#/people/member/${original._key}/`)}>
        <MemberAvatarView id={original.image} />
        <span style={{ marginLeft: '10px' }}>{value}</span>
      </a>
    ),
  },
  {
    Header: 'Name',
    accessor: 'name',
    style: { textAlign: 'left', marginLeft: 10 },
    Cell: ({ value }) => <p style={{ fontWeight: 'bold', color: 'rgb(64,64,64)' }}>{value}</p>,
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
    hideable: true,
    // hideDefault: true,
  },
  {
    Header: 'Role',
    accessor: 'role',
    width: 200,
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 150,
    Cell: ({ value }) => value && <Status value={value} tooltip={false} />,
    filterMethod: (filter, row) => {
      const activeArray = ['Active']
      const nonActiveArray = ['Inactive', 'Terminated', 'Blacklisted']
      if (filter.value === 'all') {
        return true
      }
      return filter.value === true
        ? activeArray.includes(row[filter.id])
        : nonActiveArray.includes(row[filter.id])
    },
    Filter: ({ onChange, filter }) => (
      <Select
        onChange={value => onChange(value)}
        style={{ width: '100%' }}
        value={filter ? filter.value : 'all'}>
        <Select.Option value="all">All</Select.Option>
        <Select.Option value={true}>Active</Select.Option>
        <Select.Option value={false}>None Active</Select.Option>
      </Select>
    ),
  },
]

function TeamList(props) {
  const { list, fetch, fetching, company, onChangeCompany } = props
  return (
    <CustomTable
      isFilterable={true}
      CreateButton={() => <NewEmployeeButton />}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          size={'small'}
          style={{ width: '450px', paddingRight: 20 }}
        />
      )}
      defaultFiltered={[
        {
          id: 'status',
          value: true,
        },
      ]}
      loading={fetching}
      columns={columns}
      data={list}
      fetch={fetch}
    />
  )
}

export default TeamList
